import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Row, Col } from "react-flexbox-grid";
import { TextField, Loadable } from "components/support";

class FilterView extends Component {
  state = {
    name: ""
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  };

  render() {
    const { loading } = this.props;
    const { name } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md>
              <TextField
                allowClear
                fullWidth
                label="Nome"
                value={name}
                onChange={(_, value) => this.handleField("name", value)}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default FilterView;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/filter/index.jsx